var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-certificates-modal"},[(_vm.props.name)?_c('h4',{staticClass:"t-certificates-modal__name"},[_vm._v(_vm._s(_vm.props.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"t-certificates-modal__img",class:[_vm.props.class]},[_c('img',{attrs:{"src":_vm.props.img,"alt":_vm.props.name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/certificates.vue?vue&type=template&id=073c6cf4&
// module id = 1341
// module chunks = 0